import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../app.service';
import { Attachments, DocLibraryAuditTrailsVM, DocLibraryVM, GETDocStatus, GETDocTpe, GETModels } from '../GET_NEW_UI/entities/global/model';
import { DocumentLibraryService } from '../GET_NEW_UI/services/document-library.service';
import { PreferencesService } from '../preferences/preferences.service';
import { MY_FORMATS } from '../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { AttachFileDialogComponent } from './attach-file-dialog/attach-file-dialog.component';
import { ConfirmResetDialogComponent } from './confirm-reset-dialog/confirm-reset-dialog.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-document-in-library',
  templateUrl: './document-in-library.component.html',
  styleUrls: ['./document-in-library.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class DocumentInLibraryComponent implements OnInit {

  Selectmodel_=[]
  constructor(  private _appService: AppService,  public dialog: MatDialog, 
    private _documentLibraryService:DocumentLibraryService,  private _notify: NotificationsService,
    private _route: ActivatedRoute,  private _router:Router,
    private readonly _pref: PreferencesService,) { }

  DocumentId: number = 0;
  modelList:GETModels[]=[]
  attachmentList:Attachments[]=[]
  docTypeList:GETDocTpe[]=[]
  docStatusList:GETDocStatus[]=[]
  NewFileName: string = "";
  FilePreview: string = "";

  Selectmodel:number[]=[];
  isSelectAll:boolean=false
 // Selectmodel:GETModels[];
  serialStart:string=""
  serialEnd:string=""
  docTypeID:number=0
  docHeading:string=""
  docNumber:string=""
  docRev:string=""
  docStatus:number=0
  startDate:Date
  endDate:Date
  assetAdded:boolean=false

  auditTrailList:DocLibraryAuditTrailsVM[]=[]

  isSavedEnable:boolean=true
  Loading:boolean=false;

  ngOnInit() {
    this._appService.setPageTitle('Document in Library');
    
    this.DocumentId = +this._route.snapshot.paramMap.get('DocumentId');

    
    if(this.DocumentId>0){
      this.Loading=true;
      this._documentLibraryService.getSearchedDocLibraryInfromation(this.DocumentId).subscribe(res=>{       
     this.serialStart=res.SerialStart;
     this.serialEnd=res.SerialEnd;
     this.docTypeID=res.DocTypeId;
     this.docHeading=res.DocHeading;
     this.docNumber=res.DocNo;
     this.docRev=res.DocRevNo;
     this.docStatus=res.DocStatusId;
     this.startDate=res.StartDate;
     this.endDate=res.EndDate; 
     this.Selectmodel=res.ModelId;
     this.Selectmodel_=res.ModelId;
     this.assetAdded=res.isAddedToAsset
 
      })

    // load attachments
    this._documentLibraryService.getAttachmentsDocLibraryInfromation(this.DocumentId).subscribe(res=>{
     // console.log("attschments", res)
      this.attachmentList=res
      this.Loading=false;
          })
    }
  

    this.getGETModels();
    this. getGETDocType();
    this. getGETDocStatus();
    this. getAuditTrails()
  }

  getGETModels()
  {
    this._documentLibraryService.GetGETModelList().subscribe(res=>{
    this.modelList=res
    })
  }

  
  getGETDocType()
  {
    this._documentLibraryService.GetGETDocType().subscribe(res=>{
    this.docTypeList=res
    })
  }

  
  getGETDocStatus()
  {
    this._documentLibraryService.GetGEDocStatus().subscribe(res=>{
    this.docStatusList=res
    })
  }
  filearr=[];
  openAttachDoc()
  {
   
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      data: { NewFileName:this.NewFileName,

              FilePreview:this.FilePreview
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log("res",res)
      if (res !=false) {
        this.FilePreview=res.FilePreview; 
        this.NewFileName=res.NewFileName;

        
        let obj = {
         
          Id: null,
          attachment: this.NewFileName,
          attachment_: this.FilePreview,
          DocId: this.DocumentId,    
          FileName:this.NewFileName,     
          isNew:true
        }
       

        this.attachmentList.push(obj)
        console.log(" this.attachmentList", this.attachmentList)      
      
      }
   
    });
    
  }
  


  buildnoFormControl = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.buildnoFormControl.hasError("required") ? "You must enter a value" : "";
  }


  addNewDocumentLibrary()
  { //console.log("isvalidateEndSerialnumber", this.isvalidateEndSerialnumber)

    if(this.isSavedEnable==true){
      if(this.Selectmodel.length<=0){  
        this._notify.error('Please Enter Build #')
        }
        // else if(this.serialStart==""){
        //   this._notify.error('Please Enter Serial Start #')
        // }
        // else if(this.isvalidateStartSerialnumber==false){
        //   this._notify.error('Please check the Serial Start# as this is not valid')
        // }
        // else if(this.serialEnd==""){
        //   this._notify.error('Please Enter Serial End #')
        // }
        // else if(this.isvalidateEndSerialnumber==false){
        //   this._notify.error('Please check the Serial End# as this is not valid')
        // }
        
        else if(this.docTypeID==0){
          this._notify.error('Please Enter Document Type')
        }
       
        else if(this.docStatus==0){
          this._notify.error('Please Enter Doc Status')
        }
        else{

          this.Loading=true;
          this.Selectmodel=this.Selectmodel_
    
          let model=new DocLibraryVM();
          model.ModelId=this.Selectmodel;
          model.SerialStart=this.serialStart;
          model.SerialEnd=this.serialEnd;
          model.DocTypeId=this.docTypeID;
          model.DocHeading=this.docHeading;
          model.DocNo=this.docNumber;
          model.DocRevNo=this.docRev;
          model.DocStatusId=this.docStatus;
          model.StartDate=this.startDate != null?new Date(this.startDate):null;
          model.EndDate=this.endDate !=null?new Date(this.endDate):null;
          model.isAddedToAsset=this.assetAdded
         // model.ImplementId=null
         // model.ReferenceId=null
         this._documentLibraryService.addNewDocumentLibrary(model).subscribe(docID=>{
          console.log(docID)
          
          if(docID>0){
            
            this.isSavedEnable=false
           
            if(this.attachmentList.length>0){
              this.Loading=true;
              this._documentLibraryService.addAttachmentsForDocumentLibrary(this.attachmentList, docID, this.assetAdded).subscribe(res=>{
                if(res>0){
                  this.Loading=false;
                  this._notify.success('Document successfully Uploaded');
                }
      
              })
    
            }else{
              this.Loading=false;
              this._notify.success('Document successfully Uploaded');
            }
               
          }  
        
        })
    
        }
      

    }
    else{
      this.Loading=false;
      this._notify.error('An error occurred Document already exists'); 
    }

  //  if(this.Selectmodel.length==0 || this.serialStart=="" || this.serialEnd=="" || this.docTypeID==0|| this.docNumber=="" || this.docRev =="" ||this.docStatus==0){
 
    

    
  }

  updateNewDocumentLibrary(){
    this.Loading=true;
    let model= new DocLibraryAuditTrailsVM()
    model.DocId= this.DocumentId;
    model.SerialStart=this.serialStart;    
    model.SerialEnd=this.serialEnd;
    model.DocTypeId=this.docTypeID;
   model.ModelId=this.Selectmodel
    model.DocHeading=this.docHeading !=null? this.docHeading:"";
    model.DocNo=this.docNumber !=null? this.docNumber:"";
    model.DocRevNo=this.docRev !=null? this.docRev:"";
    model.DocStatusId=this.docStatus;
    model.StartDate=this.startDate != null? new Date(this.startDate):null;
    model.EndDate=this.endDate !=null?new Date(this.endDate):null;
    model.isAddedToAsset=this.assetAdded
    

   this._documentLibraryService.addNewDocumentLibraryAuditTrailGlobal(model).subscribe(res=>{
   console.log(res)
   if(res=true){
     console.log("new Date(this.startDate)", new Date(this.startDate))
   this._documentLibraryService.updateAttachmentsForDocumentLibrary(this.attachmentList, this.DocumentId, this.assetAdded).subscribe(res=>{
      this._notify.success('Document successfully Uploaded');
      this.getAuditTrails();
      this.Loading=false;
     
  })
}
   this.getAuditTrails();
   })
  }


  //updateAttachmentsForDocumentLibrary
  getAuditTrails()
  {
    this._documentLibraryService.getAuditTrails(this.DocumentId).subscribe(res=>{
     this.auditTrailList=res;
    })
  }


  onClickDownloadForm(form, index) {
    console.log("form", form)
    console.log("form Filen name", form.FileName)

    if(form.Id!=null){
      var newstring = form.attachment_.slice(1);
      console.log('length ', newstring.length - 1)

      let _newstring = newstring.substring(0, newstring.length - 1);

      console.log("newstringnewstringnewstring", _newstring)

      var arrBuffer = this.base64ToArrayBuffer(form.attachment_);

      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
      //const linkSource = `data:application/pdf;base64,${msg}`;
      var link = document.createElement('a');
      //const fileName = "vct_illustration.pdf";

      link.href = window.URL.createObjectURL(blob);
      link.download = form.attachment + '.pdf';
      link.click();
    }
    else{
      var string =form.attachment_.split(",")[1];
      var newstring = string.slice(1);
      console.log('length ', newstring.length - 1)

      let _newstring = newstring.substring(0, newstring.length - 1);

      console.log("newstringnewstringnewstring", _newstring)

      var arrBuffer = this.base64ToArrayBuffer(string);

      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
    
      var link = document.createElement('a');
   
      link.href = window.URL.createObjectURL(blob);
      link.download = form.attachment + '.pdf';
      link.click();
    }

  }

  base64ToArrayBuffer(base64) {
    console.log("base64", base64)
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  delete(i) {
   let array =[];
   array=this.attachmentList;  
   array.splice(i,1)  
   this.attachmentList=array    
        console.log("this.attachmentList", this.attachmentList)       

  }



  	


  // selectAll(ev) {
  //   if(!this.isSelectAll){
  //  this.isSelectAll=true
  //   }
  //   if(this.isSelectAll){
  //     this.buildno.setValue(
  //       this.modelList
  //     );
  //   }
  //   else{
  //     this.buildno.setValue([]);
  //   }
  //   // console.log(ev)
  //   // if (ev._selected) {
      
  //   //     this.buildno.setValue(
  //   //       this.modelList
  //   //     );

  //   //  // ev._selected = false;
  //   // }
  //   // if (ev._selected == false) {
  //   //   this.buildno.setValue([]);
  //   // }
  //    console.log(this.buildno.value);
  //   // this.Selectmodel_=this.buildno.value
  // }




  selectAll(ev) {
   let  arr=[]
    this.isSelectAll = !this.isSelectAll;
    if(this.isSelectAll){
     

      for(let i=0; i<this.modelList.length; i++){
        arr.push(this.modelList[i].ID)
      }
     
      this.buildnoFormControl.setValue(
        arr
      );

    } 
    else{
      this.buildnoFormControl.setValue([]);
    }
    
     console.log(this.buildnoFormControl.value);
     this.Selectmodel_=this.buildnoFormControl.value
  }
  ChangeCheckbox(event){
     console.log(event.checked)
     this.assetAdded=event.checked
  }


  valueChange(ID: number) {
    console.log(this.Selectmodel_.indexOf(ID));
    if (this.Selectmodel_.indexOf(ID) > -1) {
      const pos = this.Selectmodel_.indexOf(ID);
      this.Selectmodel_.splice(pos, 1);
    } else {
      this.Selectmodel_.push(ID);
    }
    console.log(this.Selectmodel_);
  }

  NavigateToSearch(){
   // this._router.navigate(['/document-library-search']);
   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/document-library-search']);
    }else{             
      window.open('/document-library-search/', '_blank');
     
    }
});
    }

    // isvalidateStartSerialnumber:boolean=false
    // isvalidateEndSerialnumber:boolean=false
    // checkBuiltNoStart(event)
    // {
    //   console.log(event.target.value.length)
     
    //   if(event.target.value !="" && event.target.value.length>3){    
    //     if (isNaN(event.target.value.slice(event.target.value.length - 4))) {
    //       console.log(event.target.value.slice(event.target.value.length - 4))
    //       this._notify.error('Please check the Serial Start# as this is not valid')
    //       this.isvalidateStartSerialnumber=false

    //     }else 
    //       this.isvalidateStartSerialnumber=true}
    //   else{
    //     this.isvalidateStartSerialnumber=false
    //     this._notify.error('Please check the Serial Start# as this is not valid')
    //   }  
      
    // }

    // checkBuiltNoEnd(event)
    // {     
    //   console.log(event.target.value.length)
    //   if(event.target.value !="" && event.target.value.length>3){
      
    //     if (isNaN(event.target.value.slice(event.target.value.length - 4))) {
    //       console.log(event.target.value.slice(event.target.value.length - 4))
    //       this._notify.error('Please check the Serial End# as this is not valid')
    //       this.isvalidateEndSerialnumber=false

    //     }else this.isvalidateEndSerialnumber=true
    //   }else{
    //     this.isvalidateEndSerialnumber=false 
    //     this._notify.error('Please check the Serial End# as this is not valid')


    //   }  
    // }

    RestFields(){

      this.docTypeID=0;
      this.Selectmodel =[];
      this.docNumber="";
      this.startDate=null;
      this.endDate=null;
      this.serialStart="";
      this.serialEnd="";
      this.docRev="";
      this.docHeading="";
      this.docStatus=0;
      this.endDate=null;
      this.startDate = null
      this.assetAdded=false;
      this.attachmentList=[]
  
    }
  

    confirmReset()
    {
     
      const dialogRef = this.dialog.open(ConfirmResetDialogComponent, {
        data: { 
        }
      });
      dialogRef.afterClosed().subscribe(res => {
        console.log("res",res)
        if (res ==true) {
          this.RestFields();        
        
        }
     
      });
      
    }
    
}
